import { cn } from "@/lib/utils";
import { AlertCircle, CheckCircle } from "lucide-react";

interface StatusCellProps {
  hasErrors: boolean;
}

export function StatusCell({ hasErrors }: StatusCellProps) {
  return (
    <div className="@container w-full">
      <div className="flex items-center min-w-0 w-full justify-center @[50px]:justify-start @[50px]:gap-1">
        {/* Icon - always visible */}
        {hasErrors ? (
          <AlertCircle className="w-4 h-4 text-destructive flex-shrink-0" />
        ) : (
          <CheckCircle className="w-4 h-4 text-success flex-shrink-0" />
        )}

        {/* Text label - show when container >= 50px wide */}
        <span
          className={cn(
            "text-xs font-medium capitalize hidden @[50px]:block",
            hasErrors ? "text-destructive" : "text-success",
          )}
        >
          {hasErrors ? "error" : "ok"}
        </span>
      </div>
    </div>
  );
}
